import React from 'react';
import {connect} from "react-redux";
import '../style/overview.css';
import RewardsOverviewContainer from "./RewardsOverviewContainer";

class RewardsOverviewPage extends React.Component {

    render() {
        return (
            <div className="reward-overview">
                <RewardsOverviewContainer key={this.props.lang}/>
            </div>
        );
    }

}


export default connect(
    (state) => {
        return {
            lang: state.language.currentLanguage,
        }
    }
)(RewardsOverviewPage)

